import type { PropsWithChildren } from 'react';

import { ClientRender } from '@change-corgi/core-react/ssr/render';

import { ErrorMessage } from './components/ErrorMessage';
import { LoadingSkeleton } from './components/LoadingSkeleton';
import { NoResultsScreen } from './components/NoResultsScreen';
import { useSearchResultList } from './hooks/useSearchResultList';

export const SearchResultList: React.FC<PropsWithChildren> = ({ children }) => {
	return (
		<ClientRender placeholder={<LoadingSkeleton />}>
			<SearchResultListContent>{children}</SearchResultListContent>
		</ClientRender>
	);
};

const SearchResultListContent: React.FC<PropsWithChildren> = ({ children }) => {
	const {
		data: { isLoading, isError, isEmptyResults },
	} = useSearchResultList();

	if (isError) return <ErrorMessage />;
	if (isLoading) return <LoadingSkeleton />;
	if (isEmptyResults) return <NoResultsScreen />;

	return <>{children}</>;
};
